export default __webpack_public_path__ + "static/media/orders.5b3f20f5.svg";